import styles from './styles.module.scss';

const TicketDashboardNotification = () => {
  return <div className={styles.dashboardNotification} />;
};

export default TicketDashboardNotification;
